import { ErrorMapping } from 'core/types/error-mapping';
import { GraphqlError } from 'core/utils/backend-service';
import {
    CUSTOM_NOTIFICATION_NAME_ERROR_MAPPINGS,
    NAME_FIELD,
} from 'modules/settings/components/custom-notifications/custom-notification-name-error.constants';

const isAboutTheName = (error: GraphqlError): boolean =>
    !error.extensions?.field || error.extensions.field === NAME_FIELD;

const getMappedErrorType = (error: GraphqlError): ErrorMapping['type'] | undefined => {
    const errorCode = String(error.extensions?.code ?? '');

    return CUSTOM_NOTIFICATION_NAME_ERROR_MAPPINGS.find((mapping) => mapping.errorCode === errorCode)?.type;
};

// restRequest normalises a REST error body into the same { errors: [{ extensions }] }
// envelope the GraphQL client produces, so one parser serves both transports.
export const getCustomNotificationNameValidationCode = (error: Error): ErrorMapping['type'] | undefined => {
    try {
        const parsedError = JSON.parse(error.message) as { errors?: GraphqlError[] };

        for (const gatewayError of parsedError.errors ?? []) {
            const mappedErrorType = getMappedErrorType(gatewayError);

            if (mappedErrorType) {
                return mappedErrorType;
            }

            if (gatewayError.extensions?.type && isAboutTheName(gatewayError)) {
                return gatewayError.extensions.type;
            }
        }

        return undefined;
    } catch {
        return undefined;
    }
};
